import { useRH } from "../store/rh";
import { PERSONAS } from "../data/org";

export function Dashboard() {
  const hired   = useRH(s => s.totalHired());
  const cost    = useRH(s => s.totalCost());
  const power   = useRH(s => s.totalPower());
  const fired   = useRH(s => Object.values(s.employees).filter(e => e.status === "fired").length);
  const reset   = useRH(s => s.reset);
  const total   = PERSONAS.length;

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 border-2 border-ink divide-x divide-ink">
      <Stat label="Contratados" value={`${hired}`} sub={`de ${total}`} />
      <Stat label="Folha (USD/mês)" value={cost.toLocaleString("en-US")} accent="red" />
      <Stat label="Poder somado" value={`${power}`} sub="influência" />
      <Stat label="Demitidos" value={`${fired}`} sub="histórico" />
      <div className="p-4 flex flex-col justify-between">
        <div className="tag text-graydk">ações</div>
        <button
          onClick={() => { if (confirm("Resetar todo o RH?")) reset(); }}
          className="btn btn-fire mt-2">
          reset total
        </button>
      </div>
    </div>
  );
}

function Stat({ label, value, sub, accent }:
  { label: string; value: string; sub?: string; accent?: "red" }) {
  return (
    <div className="p-4">
      <div className="tag text-graydk">{label}</div>
      <div className={`font-display font-black text-4xl leading-none mt-1
        ${accent === "red" ? "text-red" : "text-ink"}`}>
        {value}
      </div>
      {sub && <div className="tag text-graydk mt-1">{sub}</div>}
    </div>
  );
}
